var _PlayroomHistorySkele, _PlayroomHistoryEmpty;
import { useCallback } from 'react';
import { clsx } from 'clsx';
import { TransactionStatusEnum, TransactionTypeEnum } from "../../../generated/graphql/types";
import { useRewardTransactionsV2 } from "../../../shared/hooks";
import { RewardRequestedCard } from "../../components";
import { usePlayroomRewardsTranslations } from "../../hooks";
import PlayroomHistoryEmpty from "./components/PlayroomHistoryEmpty";
import PlayroomHistorySkeleton from "./components/PlayroomHistorySkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomHistory = function PlayroomHistory() {
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _useRewardTransaction = useRewardTransactionsV2({
      transactionType: TransactionTypeEnum.TypeExchanged
    }),
    dataRewardTransactions = _useRewardTransaction.dataRewardTransactions,
    loadingRewardTransactions = _useRewardTransaction.loadingRewardTransactions;
  var statusEnumToType = useCallback(function (status) {
    switch (status) {
      case TransactionStatusEnum.StatusDone:
        return 'DELIVERED';
      case TransactionStatusEnum.StatusPending:
        return 'REQUESTED';
      default:
        return 'REQUESTED';
    }
  }, []);
  if (loadingRewardTransactions) {
    return _PlayroomHistorySkele || (_PlayroomHistorySkele = /*#__PURE__*/_jsx(PlayroomHistorySkeleton, {}));
  }
  if (dataRewardTransactions.length === 0) {
    return _PlayroomHistoryEmpty || (_PlayroomHistoryEmpty = /*#__PURE__*/_jsx(PlayroomHistoryEmpty, {}));
  }
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-body3 tw-mb-3.2",
      children: t('PRS_HISTORY_SECTION_DESCRIPTION')
    }), dataRewardTransactions.map(function (transaction, index) {
      var _transaction$reward$c;
      var isLast = index === dataRewardTransactions.length - 1;
      var status = statusEnumToType(transaction.current_status);
      return /*#__PURE__*/_jsx(RewardRequestedCard, {
        title: transaction.reward.name,
        coins: transaction.reward.currency_point_value || 0,
        imageSrc: (_transaction$reward$c = transaction.reward.cover_attachment) === null || _transaction$reward$c === void 0 ? void 0 : _transaction$reward$c.url,
        deliveryId: transaction.original_id,
        status: status,
        createdAt: transaction.created_at,
        className: clsx('tw-border-b tw-border-solid', isLast ? 'tw-border-b-transparent' : 'tw-border-b-neutral-light-400 dark:tw-border-b-neutral-dark-600')
      }, transaction.original_id);
    })]
  });
};
export default PlayroomHistory;